import { render, staticRenderFns } from "./Card-Toolbar-Dialog.vue?vue&type=template&id=3b6fbd63&scoped=true"
import script from "./Card-Toolbar-Dialog.vue?vue&type=script&lang=js"
export * from "./Card-Toolbar-Dialog.vue?vue&type=script&lang=js"
import style0 from "./Card-Toolbar-Dialog.vue?vue&type=style&index=0&id=3b6fbd63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fbd63",
  null
  
)

export default component.exports